// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"0": "a777a7c990c05c99","92": "751866e488074e0a",}[chunkId] + ".js"
}